import React, { ReactNode } from 'react'
import {} from 'react-router-dom'

// Layout import
import Layout from '@/components/Layout'

export interface routerType {
  path: string
  component: ReactNode
  children?: routerType[]
}

export const ignorePath = ['']
export const ignoreAuthPath = ['/board', '/']

const router: routerType[] = [
  {
    path: '/',
    component: <Layout />,
    children: [
      {
        path: '/',
        component: '../pages/home/index.tsx'
      },
      {
        path: '/board',
        component: '../pages/board/index.tsx'
      },
      {
        path: '/layout',
        component: '../pages/layout/index.tsx'
      },
      {
        path: '/local-redraw',
        component: '../pages/local-redraw/index.tsx'
      },
      {
        path: '*',
        component: '../pages/home/index.tsx'
      }
    ]
  }
]

export default router
